import _classCallCheck from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/createClass";
import { fit01 } from "@thi.ng/math";
import { dist, distSq, eqDelta, mixN, normalize, set, sub } from "@thi.ng/vectors";
import { closestPointSegment, closestT as _closestT } from "@thi.ng/geom-closest-point";
export var Sampler =
/*#__PURE__*/
function () {
  function Sampler(points) {
    var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, Sampler);

    if (closed) {
      this.points = points.slice();
      this.points.push(points[0]);
    } else {
      this.points = points;
    }

    this.buildIndex();
  }

  _createClass(Sampler, [{
    key: "totalLength",
    value: function totalLength() {
      return this.index[this.index.length - 1];
    }
  }, {
    key: "pointAt",
    value: function pointAt(t) {
      var pts = this.points;
      var n = pts.length - 1;

      if (n < 0) {
        return;
      }

      if (n === 0 || t <= 0) {
        return pts[0];
      }

      if (t >= 1) {
        return pts[n];
      }

      var idx = this.index;
      var t0 = t * idx[n];

      for (var i = 1; i <= n; i++) {
        if (idx[i] >= t0) {
          return mixN([], pts[i - 1], pts[i], (t0 - idx[i - 1]) / (idx[i] - idx[i - 1]));
        }
      }
    }
  }, {
    key: "closestPoint",
    value: function closestPoint(p) {
      var pts = this.points;
      var tmp = [];
      var closest = [];
      var minD = Infinity;

      for (var i = 0, n = pts.length - 1; i < n; i++) {
        if (closestPointSegment(p, pts[i], pts[i + 1], tmp)) {
          var d = distSq(p, tmp);

          if (d < minD) {
            minD = d;
            set(closest, tmp);
          }
        }
      }

      return closest;
    }
  }, {
    key: "closestT",
    value: function closestT(p) {
      var pts = this.points;
      var idx = this.index;
      var tmp = [];
      var closest = [];
      var minD = Infinity;
      var minI;

      for (var i = 0, n = idx.length - 1; i < n; i++) {
        if (closestPointSegment(p, pts[i], pts[i + 1], tmp)) {
          var d = distSq(p, tmp);

          if (d < minD) {
            minD = d;
            minI = i;
            set(closest, tmp);
          }
        }
      }

      return fit01(_closestT(p, pts[minI], pts[minI + 1]), idx[minI], idx[minI + 1]) / this.totalLength();
    }
  }, {
    key: "segmentAt",
    value: function segmentAt(t) {
      var i = this.indexAt(t);

      if (i === undefined) {
        return;
      }

      i = Math.max(1, i);
      return [this.points[i - 1], this.points[i]];
    }
  }, {
    key: "tangentAt",
    value: function tangentAt(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var seg = this.segmentAt(t);
      return seg ? normalize(null, sub([], seg[1], seg[0]), n) : undefined;
    }
  }, {
    key: "splitAt",
    value: function splitAt(t) {
      if (t <= 0 || t >= 1) {
        return [this.points];
      }

      var p = this.pointAt(t);
      var i = Math.max(1, this.indexAt(t));
      var head = this.points.slice(0, i);
      var tail = this.points.slice(i);

      if (!eqDelta(head[i - 1], p)) {
        head.push(p);
      }

      if (!eqDelta(tail[0], p)) {
        tail.unshift(p);
      }

      return [head, tail];
    }
  }, {
    key: "splitNear",
    value: function splitNear(p) {
      return this.splitAt(this.closestT(p));
    }
  }, {
    key: "indexAt",
    value: function indexAt(t) {
      var pts = this.points;
      var n = pts.length - 1;

      if (n < 0) {
        return;
      }

      if (n === 0 || t <= 0) {
        return 0;
      }

      if (t >= 1) {
        return n;
      }

      var idx = this.index;
      var t0 = t * idx[n];

      for (var i = 1; i <= n; i++) {
        if (idx[i] >= t0) {
          return i;
        }
      }
    }
  }, {
    key: "sampleUniform",
    value: function sampleUniform(dist) {
      var includeLast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var index = this.index;
      var pts = this.points;
      var total = this.totalLength();
      var delta = dist / total;
      var n = index.length;

      for (var t = 0, i = 1; t < 1; t += delta) {
        var ct = t * total;

        while (ct >= index[i] && i < n) {
          i++;
        }

        if (i >= n) break;
        var p = index[i - 1];
        result.push(mixN([], pts[i - 1], pts[i], (ct - p) / (index[i] - p)));
      }

      if (includeLast) {
        result.push(set([], pts[pts.length - 1]));
      }

      return result;
    }
  }, {
    key: "sampleFixedNum",
    value: function sampleFixedNum(num) {
      var includeLast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var result = arguments.length > 2 ? arguments[2] : undefined;
      return this.sampleUniform(this.totalLength() / num, includeLast, result);
    }
  }, {
    key: "buildIndex",
    value: function buildIndex() {
      var idx = [0];
      var pts = this.points;
      var n = pts.length;

      for (var i = 0, j = 1; j < n; i = j, j++) {
        idx[j] = idx[i] + dist(pts[i], pts[j]);
      }

      this.index = idx;
    }
  }]);

  return Sampler;
}();